module.exports = __webpack_public_path__ + "static/media/bonfire.59384c56.png";